module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-weapon9.png?bf50e20e";